import { useRef } from "react";
import { toast } from "sonner";
import { ImagePlus, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const MAX_SIDE = 1600;
const MAX_IMAGES = 6;

const shrink = (file) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => {
    const s = Math.min(1, MAX_SIDE / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * s);
    c.height = Math.round(img.height * s);
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(img.src);
    resolve(c.toDataURL("image/jpeg", 0.85));
  };
  img.onerror = () => reject(new Error("invalid image"));
  img.src = URL.createObjectURL(file);
});

export function QuoteImages({ images, onChange }) {
  const input = useRef(null);

  const pick = async (e) => {
    const files = [...e.target.files].slice(0, MAX_IMAGES - images.length);
    e.target.value = "";
    try {
      const added = await Promise.all(files.map(async (f) => ({ key: `${f.name}-${Date.now()}-${Math.random()}`, name: f.name, src: await shrink(f) })));
      onChange([...images, ...added]);
    } catch {
      toast.error("Não foi possível ler uma das imagens. Use JPG ou PNG.");
    }
  };

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3" data-testid="quote-images">
        {images.map((img, i) => (
          <div key={img.key} className="relative overflow-hidden rounded-md border border-slate-200 bg-white" data-testid={`quote-image-${i}`}>
            <img src={img.src} alt={img.name} className="h-32 w-full object-contain" />
            <button type="button" onClick={() => onChange(images.filter((_, j) => j !== i))} aria-label="Remover imagem" data-testid={`btn-remove-quote-image-${i}`}
              className="absolute right-1.5 top-1.5 grid h-7 w-7 place-items-center rounded-full bg-slate-900/80 text-white hover:bg-red-600"><X className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      <input ref={input} type="file" accept="image/*" multiple onChange={pick} className="hidden" data-testid="input-quote-images" />
      <Button type="button" variant="outline" disabled={images.length >= MAX_IMAGES} onClick={() => input.current.click()} className="rounded-full" data-testid="btn-add-quote-image">
        <ImagePlus className="h-4 w-4" /> Adicionar imagem
      </Button>
      <p className="text-xs text-slate-500">Até {MAX_IMAGES} imagens. Elas aparecem no fim do PDF, uma embaixo da outra.</p>
    </div>
  );
}
